import React, { useEffect, useState } from 'react';
import { Menu, X, Radar } from 'lucide-react';
import { Button } from './ui/button';
import { useContent } from '../i18n/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';

export default function Navbar() {
  const c = useContent();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? 'glass border-b border-slate-200/70 shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="lt-container flex items-center justify-between h-16 md:h-18 py-3">
        <a href="#top" className="flex items-center gap-2 group" onClick={(e) => { e.preventDefault(); scrollTo('#top'); }}>
          <span className="relative grid place-items-center w-9 h-9 rounded-xl bg-teal-600 text-white shadow-lg shadow-teal-600/30">
            <Radar className="w-5 h-5" />
          </span>
          <span className="font-display text-xl font-bold tracking-tight text-slate-900">
            LOGI<span className="text-teal-600">TAG</span>
          </span>
        </a>

        <div className="hidden lg:flex items-center gap-1">
          {c.nav.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollTo(l.href)}
              className="px-3.5 py-2 text-sm font-medium text-slate-600 hover:text-teal-700 rounded-lg hover:bg-teal-50 transition-colors"
            >
              {l.label}
            </button>
          ))}
          <a
            href="/blog"
            data-testid="nav-blog-link"
            className="px-3.5 py-2 text-sm font-medium text-slate-600 hover:text-teal-700 rounded-lg hover:bg-teal-50 transition-colors"
          >
            Blog
          </a>
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <LanguageSwitcher />
          <Button onClick={() => scrollTo('#contact')} className="btn-shine bg-teal-600 hover:bg-teal-700 text-white rounded-full px-5">
            {c.cta.demo}
          </Button>
        </div>

        <div className="lg:hidden flex items-center gap-2">
          <LanguageSwitcher />
          <button className="p-2 text-slate-800" onClick={() => setOpen(!open)} aria-label="Menu">
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </nav>

      {open && (
        <div className="lg:hidden glass border-t border-slate-200/70 px-5 py-4 space-y-1">
          {c.nav.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollTo(l.href)}
              className="block w-full text-left px-4 py-3 text-sm font-medium text-slate-700 hover:bg-teal-50 rounded-lg"
            >
              {l.label}
            </button>
          ))}
          <a href="/blog" data-testid="nav-blog-link-mobile" className="block w-full text-left px-4 py-3 text-sm font-medium text-slate-700 hover:bg-teal-50 rounded-lg">
            Blog
          </a>
          <Button onClick={() => scrollTo('#contact')} className="btn-shine w-full mt-2 bg-teal-600 hover:bg-teal-700 text-white rounded-full">
            {c.cta.demo}
          </Button>
        </div>
      )}
    </header>
  );
}
